// ViewClobButton.js
import React, { useState } from "react";
import { Button } from "@mui/material";
import { decompressFromUTF16 } from "lz-string";
import {
  WORKSPACE_CLOB_KEY,
  WORKSPACE_STATUS_TEXT_UPDATE,
} from "../constants/Constants";
import ClobViewerDialog from "./ClobViewerDialog"; // adjust path

const ViewClobButton = () => {
  const [open, setOpen] = useState(false);
  const [jsonData, setJsonData] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const handleOpen = () => {
    setButtonDisabled(true);
    setTimeout(() => {
      const storedWorkspace = localStorage.getItem(WORKSPACE_CLOB_KEY);
      if (storedWorkspace) {
        try {
          const decompressed = decompressFromUTF16(storedWorkspace);
          const parsedWorkspace = JSON.parse(decompressed); // now workspaceClob is still a JSON string

          // Parse the inner stringified workspaceClob
          if (
            parsedWorkspace.workspaceClob &&
            typeof parsedWorkspace.workspaceClob === "string"
          ) {
            parsedWorkspace.workspaceClob = JSON.parse(
              parsedWorkspace.workspaceClob
            );
          }

          setJsonData(parsedWorkspace);
          setOpen(true);
        } catch (e) {
          console.error("Error parsing workspace JSON:", e);
        }
      } else {
        console.error(
          "Workspace controller is not available and clob is not stored in session"
        );
      }
    }, 0); // Simulate a delay for the button to be disabled
  };

  const handleClose = () => {
    setOpen(false);
    setButtonDisabled(false); // re-enable button when dialog closes
  };

  return (
    <>
      <Button
        data-testid="view-clob-open-button"
        variant="contained"
        color="secondary"
        onClick={handleOpen}
        disabled={buttonDisabled}
      >
        View Clob
      </Button>
      <ClobViewerDialog
        data-testid="view-clob-dialog"
        open={open}
        onClose={handleClose}
        jsonData={jsonData}
      />
    </>
  );
};

export default ViewClobButton;
